export default (seals) =>
  [...seals].sort((first, second) => second.achieved - first.achieved);
